import { getKvList } from '@/utils/request'
import vue from '@/main'

function getDefaultState () {
  return {
    nameMap: {},
    codeNameMap: {},
    loading: {}
  }
}

const state = getDefaultState()

const mutations = {
  RESET (state) {
    Object.assign(state, getDefaultState())
  }
}

const actions = {
  // 强制刷新
  kvListForce ({ commit, state }, className) {
    delete state[className]
    vue.$set(state.loading, className, true)
    return new Promise((resolve, reject) => {
      getKvList(className).then(response => {
        vue.$set(state, className, response.data)
        const nameMap = {}
        const codeNameMap = {}
        for (const item of response.data) {
          nameMap[item.id] = item.name
          if (item.code) {
            codeNameMap[item.code] = item.name
          }
        }
        vue.$set(state.nameMap, className, nameMap)
        vue.$set(state.codeNameMap, className, codeNameMap)
        resolve(response.data)
      }).catch(error => {
        reject(error)
      }).finally(() => {
        vue.$set(state.loading, className, false)
      })
    })
  },
  kvList ({ commit, dispatch, state }, className) {
    return new Promise((resolve, reject) => {
      if (state.loading[className]) {
        resolve([])
      } else if (state.nameMap[className]) {
        resolve(state[className])
      } else {
        dispatch('kvListForce', className).then(data => {
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      }
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
